
export const canAccessLab = (user, lab) => {
  if (!user || !lab) return false;

  // admin override
  if (user.role === "admin") return true;

  const userRole = (user.role || "").toLowerCase();
  const userLevel = (user.level || "foundation").toLowerCase();

  const labIdNumber = parseInt(lab.id.replace("lab", ""), 10);

  // -----------------------------------------
  // SPECIAL RULE: partner + expert restriction
  // -----------------------------------------
  if (userRole === "partner" && userLevel === "expert") {
    const allowedLabs = [1, 2, 3, 8, 9];
    return allowedLabs.includes(labIdNumber);
  }
  // -----------------------------------------
  // DEFAULT LEVEL-BASED ACCESS RULE
  // -----------------------------------------
  let maxUnlockedLab = 0;

  if (userLevel === "foundation") {
    maxUnlockedLab = 10;
  } else if (userLevel === "advanced") {
    maxUnlockedLab = 30;
  } else if (userLevel === "expert") {
    maxUnlockedLab = 120;
  }
  return labIdNumber <= maxUnlockedLab;
};
